import { useSelector } from "react-redux";
import { DataGrid } from "../../components"
import { getLocalized } from "../../redux/localization";
import { adminPoliciesUrl } from "../../services/urls"
import createAdminPolicies from "./create";
import { PoliciesDetailPage } from "./detail";

const PoliciesPage = () => {
    const localize = useSelector(getLocalized);
    const columns = [
        {
            dataField: "AccountRole",
            caption: localize.getString("accountrole")
        },
        {
            dataField: "AccountContractType",
            caption: localize.getString("accountContractType")
        },
        {
            dataField: "Title",
            caption: localize.getString("title")
        },
        {
            dataField: "IsActive",
            caption: localize.getString("isActive")
        }
    ]

    return <DataGrid
        url={adminPoliciesUrl}
        getByIdUrl={adminPoliciesUrl}
        columns={columns}
        refObject={{}}
        title="Sözleşmeler"
        details={{
            width: "40%",
            height: "80%",
            getByIdUrl: adminPoliciesUrl,
            title: localize.getString("policyDetail"),
            component: PoliciesDetailPage,
        }}
        remove={{
            url: adminPoliciesUrl
        }}
        create={{
            createUrl: adminPoliciesUrl,
            component: createAdminPolicies,
            width: "50%",
            height: "80%",
            title: localize.getString("createPolicy")
        }}
        edit={{
            editUrl: adminPoliciesUrl,
            component: createAdminPolicies,
            width: "50%",
            height: "80%",
            title: localize.getString("editPolicy")
        }}
    />
}

export default PoliciesPage